const initialState = {
  visible: null,
  loading: null,
  payload: null,
};

export default initialState;
